import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  header: {
    id: 'Contact.header',
    defaultMessage: 'Contact Us',
  },
  supportMessage: {
    id: 'Contact.supportMessage',
    defaultMessage:
      "We're here to help! Our team is committed to providing you with the best support possible. We'll respond to your inquiry as quickly as we can. If you want to drop some feedback or suggestions, we'd love to hear from you! We're always looking for ways to improve our product and make it more useful for you.",
  },
  emailUs: {
    id: 'Contact.emailUs',
    defaultMessage: 'Email us at',
  },
  faqTitle: {
    id: 'Contact.faqTitle',
    defaultMessage: 'Frequently Asked Questions',
  },
  faq1Question: {
    id: 'Contact.faq1Question',
    defaultMessage: 'How does this work?',
  },
  faq1Answer: {
    id: 'Contact.faq1Answer',
    defaultMessage:
      'Start by creating an event. Then, share the event with your guests. They can add messages and photos to the event. You can also customize the event with a background image and a welcome message. Once your event is over, you can create a guestbook that you can print.',
  },
  faq2Question: {
    id: 'Contact.faq2Question',
    defaultMessage: 'Can I customize my guestbook?',
  },
  faq2Answer: {
    id: 'Contact.faq2Answer',
    defaultMessage:
      'Yes! After the event, you can customize the cover of the book and the fonts for the entries, but we help you with the rest. You can enjoy your event without having to think about the guestbook.',
  },
  faq3Question: {
    id: 'Contact.faq3Question',
    defaultMessage: 'How do guests add their messages?',
  },
  faq3Answer: {
    id: 'Contact.faq3Answer',
    defaultMessage:
      'Guests can easily add messages by scanning a QR code you download from the app at your event. No app download required!',
  },
  faq4Question: {
    id: 'Contact.faq4Question',
    defaultMessage: 'When can I start printing my guestbook?',
  },
  faq4Answer: {
    id: 'Contact.faq4Answer',
    defaultMessage:
      'The app is currently in beta and you can view entries in a feed. However, we are working hard at getting the printing feature ready for you so you will be able to print your guestbook immediately after the event!',
  },
  socialTitle: {
    id: 'Contact.socialTitle',
    defaultMessage: 'Join Us on Social Media',
  },
  socialMessage: {
    id: 'Contact.socialMessage',
    defaultMessage:
      'Follow us for updates, tips, and inspiration for your next event!',
  },
})
